import produce from 'immer';
import _ from 'lodash';

import { defaultProcessingState } from '../utils';

import {
  REACTION_SEARCH_PREFERENCE_CREATE_START,
  REACTION_SEARCH_PREFERENCE_CREATE_FULFILL,
  REACTION_SEARCH_PREFERENCE_CREATE_REJECT,
  REACTION_SEARCH_PREFERENCE_FIND_START,
  REACTION_SEARCH_PREFERENCE_FIND_FULFILL,
  REACTION_SEARCH_PREFERENCE_FIND_REJECT,
  REACTION_SEARCH_PREFERENCE_PATCH_START,
  REACTION_SEARCH_PREFERENCE_PATCH_FULFILL,
  REACTION_SEARCH_PREFERENCE_PATCH_REJECT,
  REACTION_SEARCH_PREFERENCE_REMOVE_START,
  REACTION_SEARCH_PREFERENCE_REMOVE_FULFILL,
  REACTION_SEARCH_PREFERENCE_REMOVE_REJECT,
} from './reaction-search-preference.actions';

const defaultState = {
  find: {
    ...defaultProcessingState(),
    initialized: false,
  },
  patch: defaultProcessingState(),
  remove: defaultProcessingState(),
  create: defaultProcessingState(),
  data: {},
};

export default produce((draft, action = {}) => {
  switch (action.type) {
    case REACTION_SEARCH_PREFERENCE_CREATE_START: {
      ++draft.create.processing;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_CREATE_FULFILL: {
      --draft.create.processing;
      draft.create.error = null;
      draft.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_CREATE_REJECT: {
      --draft.create.processing;
      draft.create.error = action.payload;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_FIND_START: {
      ++draft.find.processing;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_FIND_FULFILL: {
      --draft.find.processing;
      draft.find.error = null;
      draft.data = {
        ...draft.data,
        ..._.keyBy(action.payload.result, 'id'),
      };
      draft.find.initialized = true;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_FIND_REJECT: {
      --draft.find.processing;
      draft.find.error = action.payload;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_PATCH_START: {
      ++draft.patch.processing;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_PATCH_FULFILL: {
      --draft.patch.processing;
      draft.patch.error = null;
      const id = action.payload.result.id;
      draft.data[id] = action.payload.result;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_PATCH_REJECT: {
      --draft.patch.processing;
      draft.patch.error = action.payload;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_REMOVE_START: {
      ++draft.remove.processing;
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_REMOVE_FULFILL: {
      --draft.remove.processing;
      draft.remove.error = null;
      draft.data = _.omit(draft.data, action.payload.result);
      return draft;
    }

    case REACTION_SEARCH_PREFERENCE_REMOVE_REJECT: {
      --draft.remove.processing;
      draft.remove.error = action.payload;
      return draft;
    }

    default:
      return draft;
  }
}, defaultState);
